export function playerIsBankrupt(cash: number, ): boolean {
    return cash < 0;
}

export function playerIsUnhappy(happiness: number): boolean {
    return happiness <= 0;
}